// AdminProductos.jsx
import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { Download, BoxSeamFill, Cart4 } from 'react-bootstrap-icons';
import '../styles/tables.css';
import CrearProductoModal from './components/crearProductoModal';
import CardProducto from './components/cardProductos';
import TablaProdcutos from './components/tablaProductos';
import APIserver from '../../../api/axiosConfig';
import CrearProductoTienda from './components/crearProductoTienda';

function AdminProductos() {
  // Estado para controlar el modal producto inventario
  const [show, setShow] = useState(false);
  const [showPT, setShowPT] = useState(false); // modal producto tienda

  // Manejo del modal
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // manejo modal producto tienda
  const handleClosePT = () => setShowPT(false);
  const handleshowPT = () => setShowPT(true);

  // Función para exportar productos en formato Excel
  const handleExportarProductos = async () => {
    try {
      // Realizar solicitud al backend
      const response = await APIserver.get('/api/exportarProductos', {
        responseType: 'blob', // Asegura que la respuesta sea un archivo binario
      });

      // Validar la respuesta
      if (response.status !== 200) {
        throw new Error('Error al exportar productos');
      }

      // Crear un enlace temporal para descargar el archivo
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'productos.xlsx'); // Nombre del archivo
      document.body.appendChild(link);
      link.click();
      link.remove(); // Eliminar el enlace después de la descarga
    } catch (error) {
      console.error('Error al exportar productos:', error);
      alert('Hubo un error al exportar los productos.'); // Notificación de error al usuario
    }
  };

  return (
    <div className="mx-2 mt-3">
      {/* Encabezado y botones */}
      <div className="d-flex flex-column flex-md-row align-items-center justify-content-between">
        <p className="mb-2 mb-md-0">
          Administra tus productos e importa o exporta datos desde un solo lugar.
        </p>
        <div className="d-flex mt-2 mt-md-0">
          <Button variant="danger" onClick={handleShow}>
            <BoxSeamFill className="me-1" /> Nuevo Producto Inventario
          </Button>
          <Button variant='dark' className='ms-2' onClick={handleshowPT}>
            <Cart4 className="me-1" /> Nuevo Producto Tienda
          </Button>
          <Button variant="secondary" className="ms-2" onClick={handleExportarProductos}>
            <Download className="me-1" /> Exportar
          </Button>
        </div>
      </div>

      {/* Modal para crear un nuevo producto */}
      <CrearProductoModal show={show} handleClose={handleClose} />

      {/* Cards de productos Inventario*/}
      <div className="mt-4">
        <CardProducto />
      </div>

      {/* Cards de productos */}
      <CrearProductoTienda showPT={showPT} handleClosePT={handleClosePT}/>
      {/* Tabla de productos */}
      <div>
        <TablaProdcutos />
      </div>
    </div>
  );
}

export default AdminProductos;
